if (typeof ShippingNotice !== 'function') {

  class ShippingNotice extends HTMLElement {

    constructor() {
      super();
      this.init();
    }

    async init() {
      const cartTotal = Number(this.getAttribute('data-cart-total-amount')) / 100; // converting to euros
      let countryCode = this.getAttribute('data-country-code');

      // If no country code is available from the cart, use a geolocation API
      if (!countryCode) {
        countryCode = await this.getCountryCodeFromGeolocation();
        countryCode = countryCode.toUpperCase();
      }

      // Log the detected country code
      console.log('Detected Country Code:', countryCode);

      // Define default and country-specific thresholds
      const freeShippingThresholds = {
        DEFAULT: Number(this.getAttribute('data-free-shipping-default')) / 100 || 0,
        FI: Number(this.getAttribute('data-free-shipping-FI')) / 100 || 0,
        LT: Number(this.getAttribute('data-free-shipping-LT')) / 100 || 0,
        DE: Number(this.getAttribute('data-free-shipping-DE')) / 100 || 0,
        FR: Number(this.getAttribute('data-free-shipping-FR')) / 100 || 0,
        HU: Number(this.getAttribute('data-free-shipping-HU')) / 100 || 0,
        LV: Number(this.getAttribute('data-free-shipping-LV')) / 100 || 0,
        US: Number(this.getAttribute('data-free-shipping-LV')) / 100 || 0,
        SE: Number(this.getAttribute('data-free-shipping-LV')) / 100 || 0,
        BE: Number(this.getAttribute('data-free-shipping-LV')) / 100 || 0,
        AT: Number(this.getAttribute('data-free-shipping-LV')) / 100 || 0,
        SI: Number(this.getAttribute('data-free-shipping-LV')) / 100 || 0,
        IT: Number(this.getAttribute('data-free-shipping-LV')) / 100 || 0,
        IE: Number(this.getAttribute('data-free-shipping-LV')) / 100 || 0,
        CH: Number(this.getAttribute('data-free-shipping-LV')) / 100 || 0,
        PT: Number(this.getAttribute('data-free-shipping-LV')) / 100 || 0,
        CZ: Number(this.getAttribute('data-free-shipping-LV')) / 100 || 0,
        CA: Number(this.getAttribute('data-free-shipping-LV')) / 100 || 0
      };

      const extraFreeShippingThresholds = {
        DEFAULT: Number(this.getAttribute('data-extra-free-shipping-default')) / 100 || 0,
        FI: Number(this.getAttribute('data-extra-free-shipping-FI')) / 100 || 0,
        LT: Number(this.getAttribute('data-extra-free-shipping-LT')) / 100 || 0,
        DE: Number(this.getAttribute('data-extra-free-shipping-DE')) / 100 || 0,
        FR: Number(this.getAttribute('data-extra-free-shipping-FR')) / 100 || 0,
        HU: Number(this.getAttribute('data-extra-free-shipping-HU')) / 100 || 0,
        LV: Number(this.getAttribute('data-extra-free-shipping-LV')) / 100 || 0,
        US: Number(this.getAttribute('data-extra-free-shipping-LV')) / 100 || 0,
        SE: Number(this.getAttribute('data-extra-free-shipping-LV')) / 100 || 0,
        BE: Number(this.getAttribute('data-extra-free-shipping-LV')) / 100 || 0,
        AT: Number(this.getAttribute('data-extra-free-shipping-LV')) / 100 || 0,
        SI: Number(this.getAttribute('data-extra-free-shipping-LV')) / 100 || 0,
        IT: Number(this.getAttribute('data-extra-free-shipping-LV')) / 100 || 0,
        IE: Number(this.getAttribute('data-extra-free-shipping-LV')) / 100 || 0,
        CH: Number(this.getAttribute('data-extra-free-shipping-LV')) / 100 || 0,
        PT: Number(this.getAttribute('data-extra-free-shipping-LV')) / 100 || 0,
        CZ: Number(this.getAttribute('data-extra-free-shipping-LV')) / 100 || 0,
        CA: Number(this.getAttribute('data-extra-free-shipping-LV')) / 100 || 0
      };

      // Log the input values for debugging
      console.log('Cart Total:', cartTotal);
      console.log('Free Shipping Thresholds:', freeShippingThresholds);
      console.log('Extra Free Shipping Thresholds:', extraFreeShippingThresholds);

      // Get the thresholds for the current country or fallback to default
      const freeShippingThreshold = freeShippingThresholds[countryCode] || freeShippingThresholds.default;
      const extraFreeShippingThreshold = extraFreeShippingThresholds[countryCode] || extraFreeShippingThresholds.default;

      // Log the thresholds being used
      console.log('Free Shipping Threshold:', freeShippingThreshold);
      console.log('Extra Free Shipping Threshold:', extraFreeShippingThreshold);

      const freeShippingRemaining = freeShippingThreshold - cartTotal;
      const extraFreeShippingRemaining = extraFreeShippingThreshold - cartTotal;

      // Log the remaining amounts
      console.log('Free Shipping Remaining:', freeShippingRemaining);
      console.log('Extra Free Shipping Remaining:', extraFreeShippingRemaining);

      let shippingMessage = '';
      let shippingSuccess = false;

      if (cartTotal < freeShippingThreshold) {
        shippingMessage = window.KROWN.settings.locales.shipping_notice_remaining_to_free.replace('{{ remaining_amount }}', this._formatMoney(freeShippingRemaining * 100, KROWN.settings.shop_money_format));
      } else if (extraFreeShippingThreshold > 0 && cartTotal < extraFreeShippingThreshold) {
        shippingMessage = window.KROWN.settings.locales.shipping_notice_remaining_to_extra_free.replace('{{ remaining_amount }}', this._formatMoney(extraFreeShippingRemaining * 100, KROWN.settings.shop_money_format));
      } else if (extraFreeShippingThreshold > 0 && cartTotal >= extraFreeShippingThreshold) {
        shippingMessage = window.KROWN.settings.locales.shipping_notice_eligible_for_extra_free;
        this.showFreebar(); // Show the freebar when extraFreeShippingThreshold is met
        shippingSuccess = true;
      } else if (cartTotal >= freeShippingThreshold) {
        shippingMessage = window.KROWN.settings.locales.shipping_notice_eligible_for_free;
        shippingSuccess = true;
      }

      // Log the final message and success status
      console.log('Shipping Message:', shippingMessage);
      console.log('Shipping Success:', shippingSuccess);

      if (this.hasAttribute('data-show-alert')) {
        this.innerHTML = `
          <div class="alert alert--wide alert--${shippingSuccess ? 'success' : 'note'}">
            ${shippingMessage}
          </div>`;
      } else {
        this.innerHTML = shippingMessage;
      }

      if (shippingMessage != '') {
        this.style.display = 'block';
      }

      const checkoutButton = document.querySelector('#CheckOut');
      if (checkoutButton != null) {
        checkoutButton.addEventListener('click', (e) => {
          const t = e.target;
          const parentEl = t.parentElement;
          const ageConfirm = parentEl.querySelector('#ageConfirm');
          const errorMessage = parentEl.querySelector('#error-message');
          
          if (!ageConfirm.checked) {
            e.preventDefault();
            e.stopPropagation();
            
            errorMessage.style.display = 'block';
          } else {
            errorMessage.style.display = 'none';
          }
        });
      }
    }

    async getCountryCodeFromGeolocation() {
      try {
        const response = await fetch('https://ipapi.co/json/?key=sOj1zHcxXJRzvQIbgT9zlRlH7Atr9SldtIMglvbWC1OExlIkO9');
        const data = await response.json();
        console.log('Geolocation API Response:', data); // Log the full response from the API
        return data.country_code || 'default';
      } catch (error) {
        console.error('Geolocation API error:', error);
        return 'default';
      }
    }

    showFreebar() {
      const freebar = document.querySelector('.freebar');
      if (freebar) {
        freebar.style.display = 'block';
      }
    }

    _formatMoney(cents, format) {
      if (typeof cents === 'string') {
        cents = cents.replace('.', '');
      }

      let value = '';
      const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      const formatString = format || moneyFormat;

      function formatWithDelimiters(number, precision, thousands, decimal) {
        thousands = thousands || ',';
        decimal = decimal || '.';

        if (isNaN(number) || number === null) {
          return 0;
        }

        number = (number / 100.0).toFixed(precision);

        const parts = number.split('.');
        const dollarsAmount = parts[0].replace(
          /(\d)(?=(\d\d\d)+(?!\d))/g,
          '$1' + thousands
        );
        const centsAmount = parts[1] ? decimal + parts[1] : '';

        return dollarsAmount + centsAmount;
      }

      switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
          value = formatWithDelimiters(cents, 2);
          break;
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
        case 'amount_no_decimals_with_space_separator':
          value = formatWithDelimiters(cents, 0, ' ');
          break;
        case 'amount_with_apostrophe_separator':
          value = formatWithDelimiters(cents, 2, "'");
          break;
      }

      return formatString.replace(placeholderRegex, value);
    }
  }

  if (typeof customElements.get('shipping-notice') == 'undefined') {
    customElements.define('shipping-notice', ShippingNotice);
  }

}

document.addEventListener('DOMContentLoaded', function() {
    const shippingNotice = document.querySelector('.cart-notice.hide-if-empty-cart');
    if (shippingNotice) {
        const cartTotalWeight = shippingNotice.getAttribute('data-cart-total-weight');
        console.log('Total Weight in Cart:', cartTotalWeight);
    }
});



